import { Directive, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[ttFileDrop]',
  standalone: true,
})
export class FileDropDirective {
  @Input() public allowedTypes: string[] = [];
  @Output() public fileDrop = new EventEmitter<File>();
  @Output() public fileHover = new EventEmitter<boolean>();
  @Output() public invalidExtension: EventEmitter<string> = new EventEmitter();

  @HostBinding('class.file-drop-active') public active = false;
  @HostBinding('style.background') public backgroundColor = 'rgba(242, 244, 247, 1)';
  @HostBinding('style.border') public border = '1px dashed rgba(208, 213, 221, 1)';
  @HostBinding('style.border-radius') public borderRadius = '8px';

  @HostListener('dragover', ['$event'])
  public onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.active = true;

    this.backgroundColor = 'rgb(242, 249, 255)';
    this.border = '2px dashed rgb(6, 61, 112)';

    this.fileHover.emit(true);
  }

  @HostListener('dragleave', ['$event'])
  public onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.active = false;

    this.backgroundColor = 'rgb(255, 255, 255)';
    this.border = '2px dashed rgb(208, 220, 231)';

    this.fileHover.emit(false);
  }

  @HostListener('drop', ['$event'])
  public onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.active = false;

    this.backgroundColor = 'rgb(255, 255, 255)';
    this.border = '2px dashed rgb(208, 220, 231)';

    this.fileHover.emit(false);

    const files = event.dataTransfer?.files;
    if (files && files.length) {
      const file = files[0];

      if (this.allowedTypes.length) {
        const fileExtension = file.name.split('.').pop()?.toLowerCase();
        const isAllowed = this.allowedTypes.some((type) => type.toLowerCase() === fileExtension);

        if (isAllowed) {
          this.fileDrop.emit(file);
        } else {
          this.invalidExtension.emit(fileExtension);
        }
      } else {
        this.fileDrop.emit(file);
      }
    }
  }
}
